module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/logo_colorful-f53472fb6c98d08ad197651b05fd2a12.svg";